<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
            <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">Hardware QC</h4>
              <button class="float-right btn btn-primary shadow mt-2" v-on:click="formHardwareQualityControlActive=!formHardwareQualityControlActive">{{dicts.label_tambah_hardware_qc[dicts.lang]}}</button>
              <button class="float-right btn btn-primary shadow mt-2 mr-2" v-on:click="stockActive=!stockActive">Stock</button>
            </div>
            <transition name="fade">
              <div class="col-12  my-2 py-0" v-if="stockActive">
                <div class="p-3 mx-2 bg-white shadow">
                  <!-- <div class="col-xl-6 col-md-6" v-for="item in stock.qc" v-bind:key="'item'+item.id">
                    <stats-card>
                      <div slot="header" class="icon-warning">
                        <i class="nc-icon nc-app text-warning w-100"></i>
                      </div>
                      <div slot="content">
                        <p class="card-category">Stock {{item.po_item}}</p>
                        <h4 class="card-title">{{item.total}}</h4>
                      </div>
                      <div slot="footer">
                        <i class="fa fa-refresh"></i>Updated now
                      </div>
                    </stats-card>
                  </div>
                </div> -->
                  <chart-card
                    v-if="true"
                    :chart-data="HardwareQcCart.data"
                    :chart-options="HardwareQcCart.options"
                    :chart-responsive-options="HardwareQcCart.responsiveOptions"
                    chart-type="Bar"
                    width="100%">
                    <template slot="header">
                      <h5 class="card-title text-center mb-3">Stock Hardware</h5>
                    </template>
                  </chart-card>
                </div>
              </div>
            </transition>
            <transition name="fade">
            <div class="col-12  my-2 py-0" v-if="formHardwareQualityControlActive">
                <div class="row p-3 mx-2 bg-white shadow">

                <div class="col-12 w-100 my-3">
                  <!-- <ul class="nav nav-tabs">
                      <li class="nav-item">
                          <button class="nav-link" :class="[selectedTab==0?'active':'']" href="#" v-on:click="selectedTab=0;totalNewDetail=totalNewAntena;">Antena</button>
                      </li>
                      <li class="nav-item">
                          <button class="nav-link" :class="[selectedTab==1?'active':'']" href="#" v-on:click="selectedTab=1;totalNewDetail=totalNewJB;">Junction Box</button>
                      </li>
                    </ul> -->
                    
                    <div class="w-100">
                      <div class="col-12 my-3">
                        <h4 class="my-0 py-0">{{dicts.label_form_hardware_qc_baru[dicts.lang]}}</h4>
                        <hr>
                      </div>
                      <div class="row">
                        <div class="col-12 col-md-6 col-lg-4 mt-2">
                          <label class="d-block">{{dicts.label_no_po[dicts.lang]}}</label>
                          <smart-search init url="/api/pemesanan/seeker/purchaseorder?ready=yes" key-tag="no_po" v-on:clear="(res)=>{clearPOData()}" v-on:update="(data)=>{newHardwareQualityControl.sn=data.id;newMetaCounter=0;newMeta=data.metadata;addOnSmartSearch.hardware.no_po=data.id;totalNewDetail=data.metadata[0].qty;calculateTotalNew(data.metadata)}" :search-value="newhardwareqclabel" @update-direct="(label)=>newhardwareqclabel=label"></smart-search>
                          <!-- <input type="text"  class="form-control w-100 rounded" v-model="newHardwareQualityControl.antena.sn" v-if="selectedTab==0" />
                          <input type="text"  class="form-control w-100 rounded" v-model="newHardwareQualityControl.jb.sn" v-if="selectedTab==1" /> -->
                        </div>
                        <!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
                          <label class="d-block">Type</label>
                          <smart-select name="item" :options="statusTypeOptions" v-on:update="updateNewHardwareQcStatus"></smart-select>
                        </div> -->
                      </div>
                      <div class="col-12 mt-3">
                        <div class="col-12 mt-4">
                          <div class="row shadow-sm rounded my-3 px-2 py-4" v-for="(hardware,index) in newHardwares" v-bind:key="'ttl'+hardware.id">
                            <div class="col-6">
                              <h4>Detail #{{index+1}}</h4>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 text-right">
                              <!-- <b-button variant="danger" @click="deleteNewHardware(ttl-1)"><b-icon icon="trash" class="text-danger text-right"></b-icon></b-button> -->
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mt-2">
                              <label class="d-block">{{dicts.label_nomor_sn[dicts.lang]}}</label>
                              <input type="text"  class="form-control w-100 rounded" v-model="newHardwareQualityControl.noSN[index]" @input="fillHardware(index,null,hardware.id)"   />
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mt-2">
                              <label class="d-block">{{dicts.label_perangkat[dicts.lang]}}</label>
                              <input type="hidden"  class="form-control w-100 rounded" v-model="newHardwareQualityControl.hardwareId[index]"  />
                              <input text="text" class="form-control w-100 rounded" v-model="hardware.name" readonly/>
                              <!-- <smart-search init url="/api/master/seeker/hardware" :addon="{no_po:newHardwareQualityControl.sn}" key-tag="hardware_name" v-on:update="(data)=>updateMetaHardwareQc(data,index+1)"></smart-search> -->
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mt-2">
                                <label class="d-block">{{dicts.label_tanggal[dicts.lang]}}</label>
                                <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" :id="'datepicker-newQc'+[index]" v-model="newHardwareQualityControl.date[index]" class="mb-2">{{newHardwareQualityControl.date[index]}}</b-form-datepicker>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mt-2">
                              <label class="d-block">{{dicts.label_keterangan[dicts.lang]}}</label>
                              <textarea type="text" class="form-control w-100 rounded" v-model="newHardwareQualityControl.comment[index]"  />
                            </div>
                          </div>
                        <!-- <button type="button" class="btn btn-light w-100 shadow-sm shadow" v-on:click="addNewHardware()">Tambah Hardware Quality Control Detail</button> -->
                        </div>
                      </div>
                      <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="newHardwareQualityControlSaved">
                          <div class="alert alert-success" role="alert">
                              Berhasil Menyimpan Quality Control Baru.
                          </div>
                        </div>
                      </div>
                        
                      <div class="col-12 mt-3">
                          <div class="w-100 align-items-center justify-content-start" v-if="errorNewHardwareQualityControl">
                              <div class="alert alert-danger" role="alert">
                                  <div class="my-0">
                                      <p  class="d-block mt-1">Gagal Menyimpan Quality Control Baru.</p>
                                  </div>
                                  <div v-for="err in errorHardwareQualityControlList" v-bind:key="err" class="my-0">
                                      <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-12 mt-3">
                          <div class="d-flex align-items-center justify-content-start" v-if="savingNewHardwareQualityControl">
                              <div class="spinner-border" role="status" aria-hidden="true"></div>
                              <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                          </div>
                          <button class="btn btn-primary float-right" type="button" v-on:click="saveNewHardwareQc">{{dicts.label_simpan[dicts.lang]}}</button>
                      </div>
                    </div>
                    
                    
                  </div>
                </div>
            </div>
            </transition>

            <div class="col-12  my-2 py-0">
              <datatable :lang="dicts.lang" :datas="hardwarequalitycontrols" :structure="hardwarequalitycontrolTableStructure" :init="loadData" :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}" use-seeker seeker-url="/api/inventaris/seeker/hardware-qc" @refetch="(row)=>{rowLimit=row;getHardwareQualityControls()}" @searching="(val)=>!val.status?getHardwareQualityControls():hardwarequalitycontrols=val.data" @change-url="(url)=>getHardwareQualityControls(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)">
                <template #customcell={obj,index}>
                    <td v-if="isMobile" class="py-3">
                        <ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">{{dicts.label_no_po[dicts.lang]}}:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.purchase_order!=null?obj.purchase_order.no_po:'-' }}</b>
                                </div>
                                <hr class="my-1">
                            </li>
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">{{dicts.label_nomor_sn[dicts.lang]}}:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">
                                      {{ 
                                        (Array.isArray(obj.metadata) && obj.metadata.length > 0) ? 
                                        obj.metadata[obj.metadata.length-1].serial_number 
                                        :
                                        "-"
                                      }}
                                      </b>
                                </div>
                                
                            </li>
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">{{dicts.label_tipe[dicts.lang]}}:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">
                                      {{
                                        (Array.isArray(obj.metadata) && obj.metadata.length > 0) && 
                                        obj.metadata[obj.metadata.length-1].purchase_order_metadata!=null&&
                                        obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware!=null
                                        ?
                                        //if true
                                        obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware.item
                                        :
                                        //if false
                                        '-'
                                      }}
                                      </b>
                                </div>
                                
                            </li>
                            
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">{{dicts.label_perangkat[dicts.lang]}}:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">
                                      {{
                                        (Array.isArray(obj.metadata) && obj.metadata.length > 0) && 
                                        obj.metadata[obj.metadata.length-1].purchase_order_metadata!=null&&
                                        obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware!=null
                                        ?
                                        //if true
                                        obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware.hardware_name
                                        :
                                        //if false
                                        '-'
                                      }}
                                      </b>
                                </div>
                                <hr class="my-1">
                            </li>
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <b-button v-b-modal.modal-detail-hardwareqc class="btn btn-primary mr-2 mb-1" v-on:click="selectedDetail=index"><b-icon icon="eye"></b-icon></b-button>
                                    <b-button v-b-modal.modal-edit-hardwareqc class="btn btn-info mr-2 mb-1" v-on:click="selectedIdforEdit=index"><b-icon icon="pencil-square"></b-icon></b-button>
                                    <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger mr-2 mb-1"><b-icon icon="trash"></b-icon></b-button>
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td v-if="!isMobile">{{index+1}}</td>
                    <td v-if="!isMobile">{{obj.purchase_order!=null?obj.purchase_order.no_po:'-'}}</td>
                    <td v-if="!isMobile">
                      {{ 
                        (Array.isArray(obj.metadata) && obj.metadata.length > 0) ? 
                        obj.metadata[obj.metadata.length-1].serial_number 
                        :
                        "-"
                      }}
                      </td>
                    <td v-if="!isMobile">
                      {{
                        (Array.isArray(obj.metadata) && obj.metadata.length > 0) && 
                        obj.metadata[obj.metadata.length-1].purchase_order_metadata!=null&&
                        obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware!=null
                        ?
                        //if true
                        obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware.item
                        :
                        //if false
                        '-'
                      }}
                      </td>
                    
                    <td v-if="!isMobile">
                      {{
                        (Array.isArray(obj.metadata) && obj.metadata.length > 0) && 
                        obj.metadata[obj.metadata.length-1].purchase_order_metadata!=null&&
                        obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware!=null
                        ?
                        //if true
                        obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware.hardware_name
                        :
                        //if false
                        '-'
                      }}
                      
                      </td>
                    <!-- <td>
                      <table class="w-100 shadow-sm">
                        <tr>
                          <th class="w-50">Nomor SN</th>
                          <th>Tipe</th>
                          <th>Perangkat</th>
                        </tr>
                        <tr class="w-100">
                          <td><small>{{ 
                                        (Array.isArray(obj.metadata) && obj.metadata.length > 0) ? 
                                        obj.metadata[obj.metadata.length-1].serial_number 
                                        :
                                        "-"
                                      }}</small></td>
                          <td><small>{{obj.metadata[obj.metadata.length-1].purchase_order_metadata!=null&&obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware!=null?obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware.item:'-'}}</small></td>
                          <td><small>{{obj.metadata[obj.metadata.length-1].purchase_order_metadata!=null&&obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware!=null?obj.metadata[obj.metadata.length-1].purchase_order_metadata.hardware.hardware_name:'-'}}</small></td>
                        </tr>
                      </table>
                    </td> -->
                    <td v-if="!isMobile">
                      <b-button v-b-modal.modal-detail-hardwareqc class="btn btn-primary mr-2 mb-1" v-on:click="selectedDetail=index"><b-icon icon="eye"></b-icon></b-button>
                      <b-button v-b-modal.modal-edit-hardwareqc class="btn btn-info mr-2 mb-1" v-on:click="selectedIdforEdit=index"><b-icon icon="pencil-square"></b-icon></b-button>
                      <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger mr-2 mb-1"><b-icon icon="trash"></b-icon></b-button>
                    </td>
                </template>
              </datatable>
            </div>

          <b-modal no-close-on-esc  content-class="m-0"  id="modal-edit-hardwareqc" title="Edit data" no-close-on-backdrop size="lg" scrollable @hide="editModalClose" v-if="hardwarequalitycontrols.length>0">
              <div class="row" v-if="hardwarequalitycontrols[selectedIdforEdit]!=undefined">
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">{{dicts.label_no_po[dicts.lang]}}</label>
                      <!-- <smart-search init url="/api/pemesanan/seeker/purchaseorder?ready=yes" usedefault :default-value="hardwarequalitycontrols[selectedIdforEdit].purchase_order.no_po" key-tag="no_po" v-on:update="(data)=>smartSearchUpdatedNoPo(data)" readonly></smart-search> -->
                      <input type="text"  class="form-control w-100 rounded" v-model="hardwarequalitycontrols[selectedIdforEdit].purchase_order.no_po" readonly/>
                  </div>
              </div>

              <div class="row mt-3 pb-1" v-if="hardwarequalitycontrols[selectedIdforEdit].metadata!=null">
                  <div class="col-12">
                      <hr>
                  </div>
                  <div class="col-12">
                      <h4>Detail Hardware QC</h4>
                  </div>
                  <div class="col-12">
                      <div class="row" v-for="(metadata,index) in hardwarequalitycontrols[selectedIdforEdit].metadata" v-bind:key="'metadata'+index">

                          <div class="col-12 col-md-6 col-lg-4 mt-2">
                              <label class="d-block">{{dicts.label_nomor_sn[dicts.lang]}}</label>
                              <input type="text"  class="form-control w-100 rounded" v-model="metadata.serial_number" />
                          </div>
                          <div class="col-12 col-md-6 col-lg-4 mt-2">
                              <label class="d-block">{{dicts.label_perangkat[dicts.lang]}}</label>
                              <!-- <input type="text"  class="form-control w-100 rounded" v-model="metadata.purchase_order_metadata.hardware.hardware_name" /> -->
                              <!-- <smart-search init url="/api/master/seeker/hardware" :addon="{hardware_type_by_po_id:hardwarequalitycontrols[selectedIdforEdit].no_po_id}" :usedefault="true" :default-value="metadata.purchase_order_metadata.hardware.hardware_name" :label-tag="['hardware_name']" key-tag="hardware_name" v-on:update="(data)=>editMetaHardwareQc(data)"></smart-search> -->
                              <input text="text" class="form-control w-100 rounded" v-model="metadata.purchase_order_metadata.hardware.hardware_name" readonly/>
                          </div>
                          <div class="col-12 col-md-6 col-lg-4 mt-2">
                              <label class="d-block">{{dicts.label_tanggal[dicts.lang]}}</label>
                              <!-- <input type="text"  class="form-control w-100 rounded" v-model="metadata.date" /> -->
                              <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" :id="'datepicker-editQc'+[index]" v-model="metadata.date" class="mb-2">{{metadata.date}}</b-form-datepicker>
                          </div>
                          <div class="col-12 col-md-6 col-lg-4 mt-2">
                              <label class="d-block">{{dicts.label_keterangan[dicts.lang]}}</label>
                              <textarea type="text"  class="form-control w-100 rounded" v-model="metadata.comment" />
                          </div>
                          <div class="col-12 mt-3">
                            <div class="w-100 align-items-center justify-content-start" v-if="updating  && (metaEditIndex==index)">
                                <div class="alert alert-secondary" role="alert">
                                    Menyimpan data, tunggu sebentar.
                                </div>
                            </div>
                          <div class="col-12 mt-3">
                              <div class="w-100 align-items-center justify-content-start" v-if="updateSaved  && (metaEditIndex==index)">
                                  <div class="alert alert-success" role="alert">
                                      Berhasil Update Data Purchase Order.
                                  </div>
                              </div>
                          </div>
                          <div class="col-12 mt-3">
                              <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate  && (metaEditIndex==index)">
                                  <div class="alert alert-success" role="alert">
                                      Gagal update Purchase Order.
                                  </div>
                              </div>
                          </div>
                      <div class="col-12 text-right">
                          <button class="btn btn-info" v-on:click="updateHardwareQualityControl(index)">{{dicts.label_simpan[dicts.lang]}}</button>
                      </div>
                          
                          <div class="col-12">
                              <hr/>
                          </div>
                      </div>
                      </div>
                      
                  </div>
              </div>

            <template #modal-footer>
              <div class="w-100 text-right m-0 p-0">
                <hr>
                <button class="btn btn-info mr-2" v-on:click="saveNewHardwareQcBulk">{{dicts.label_simpan[dicts.lang]}}</button>
                <b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-edit-hardwareqc'):''">{{dicts.label_tutup[dicts.lang]}}</b-button>
              </div>
            </template>
              <!-- <template #modal-footer>
                  <div class="w-100 text-right m-0 p-0">
                      <hr> 
                      <div class="col-12 mt-3">
                          <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
                              <div class="alert alert-danger" role="alert">
                                  <div class="my-0">
                                      <p  class="d-block mt-1 text-left">Gagal update Purchase Order.</p>
                                  </div>
                                  <div v-for="err in errorHardwareQualityControlList" v-bind:key="err" class="my-0">
                                      <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-12 mt-3">
                          <div class="d-flex align-items-center justify-content-start" v-if="updating">
                              <div class="spinner-border" role="status" aria-hidden="true"></div>
                              <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                          </div>
                          <b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-hardwareqc')">Tutup</b-button>
                      </div>
                  </div>
              </template> -->
          </b-modal>

          <b-modal no-close-on-esc  content-class="m-0"  id="modal-detail-hardwareqc" size="xl" title="Detail purchase order" scrollable no-close-on-backdrop @hide="detailModalClose">
              <b-container fluid v-if="!loadData&&hardwarequalitycontrols.length>0">
                  <b-row class="pt-1" v-if="hardwarequalitycontrols[selectedDetail]!=undefined">
                    <div style="overflow-x:auto;">
                    <table v-if="hardwarequalitycontrols.length>0" rules="all" border="0" class="table-detail w-100">
                      <tbody>
                        <tr>
                          <th>No</th>
                          <th>{{dicts.label_no_po[dicts.lang]}}</th>
                          <th>{{dicts.label_kode_barang[dicts.lang]}}</th>
                          <th>{{dicts.label_nomor_sn[dicts.lang]}}</th>
                          <th>{{dicts.label_tipe[dicts.lang]}}</th>
                          <th>{{dicts.label_perangkat[dicts.lang]}}</th>
                          <th>{{dicts.label_tanggal[dicts.lang]}}</th>
                          <th>{{dicts.label_keterangan[dicts.lang]}}</th>
                          <th>{{dicts.label_warehouse[dicts.lang]}}</th>
                          <th>{{dicts.label_status[dicts.lang]}}</th>
                        </tr>
                        <tr v-for="(meta,index) in hardwarequalitycontrols[selectedDetail].metadata" :key="'qcmeta'+meta">
                        <td>{{index+1}}</td>
                        <td>{{meta.purchase_order_metadata!=null&&meta.purchase_order_metadata.order!=null?meta.purchase_order_metadata.order.no_po:''}}</td>
                        <td>{{meta.purchase_order_metadata!=null&&meta.purchase_order_metadata.hardware!=null?meta.purchase_order_metadata.hardware.part_number:'-'}}</td>
                        <td>{{meta.serial_number}}</td>
                        <td>{{meta.purchase_order_metadata!=null&&meta.purchase_order_metadata.hardware!=null?meta.purchase_order_metadata.hardware.item:''}}</td>
                        <td>{{meta.purchase_order_metadata!=null&&meta.purchase_order_metadata.hardware!=null?meta.purchase_order_metadata.hardware.hardware_name:''}}</td>
                        <td>{{meta.date | timeformat}}</td>
                        <td>{{meta.comment}}</td>
                        <td>{{meta.warehouse != null?meta.warehouse.warehouse_name:''}}</td>
                        <td>{{meta.used}}</td>
                        </tr>
                      </tbody>
                      <!-- <tr class="w-100">
                        <th>NO PO</th>
                        <th class="px-2 py-2">Kode Barang</th>
                        <th class="px-2 py-2">Nomor SN</th>
                        <th class="px-2 py-2">Tipe</th>
                        <th class="px-2 py-2">Perangkat</th>
                        <th class="px-2 py-2">Tanggal</th>
                        <th class="px-2 py-2">Keterangan</th>
                      </tr>
                      <tr v-for="meta in hardwarequalitycontrols[selectedDetail].metadata" :key="'qcmeta'+meta">
                        <td class="px-2 py-2">{{meta.purchase_order_metadata!=null&&meta.purchase_order_metadata.order!=null?meta.purchase_order_metadata.order.no_po:''}}</td>
                        <td class="px-2 py-2">{{meta.purchase_order_metadata!=null&&meta.purchase_order_metadata.hardware!=null?meta.purchase_order_metadata.hardware.part_number:'-'}}</td>
                        <td class="px-2 py-2">{{meta.serial_number}}</td>
                        <td class="px-2 py-2">{{meta.purchase_order_metadata!=null&&meta.purchase_order_metadata.hardware!=null?meta.purchase_order_metadata.hardware.item:''}}</td>
                        <td class="px-2 py-2">{{meta.purchase_order_metadata!=null&&meta.purchase_order_metadata.hardware!=null?meta.purchase_order_metadata.hardware.hardware_name:''}}</td>
                        <td class="px-2 py-2">{{meta.date | timeformat}}</td>
                        <td class="px-2 py-2">{{meta.comment}}</td>
                      </tr> -->
                    </table>
                    </div>
                  
                    <!-- <b-col cols="12" class="my-3 text-right"  v-if="deleteState">
                    <div class="d-flex align-items-center justify-content-start">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
                        </div>
                    </b-col>
                    <div class="col-12 mt-3"  v-if="deleted">
                        <div class="w-100 align-items-center justify-content-start">
                            <div class="alert alert-success" role="alert">
                                Berhasil menghapus data klien.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3"  v-if="deleteFail">
                        <div class="w-100 align-items-center justify-content-start">
                            <div class="alert alert-danger" role="alert">
                                Gagal menghapus data klien.
                            </div>
                        </div>
                    </div> -->
                  </b-row>
              </b-container>
              <template #modal-footer>
                  <div class="w-100 text-right m-0 p-0">
                  <hr>
                  <!-- <button class="btn btn-danger mr-2" v-on:click="deleteData">Ya, hapus</button> -->
                  <b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-detail-hardwareqc'):''">{{dicts.label_tutup[dicts.lang]}}</b-button>
                  </div>
              </template>
          </b-modal>

          <!-- <template>
            <b-modal id="modal-add-detail-hardwareqc" title="Add Detail Hardware QC" size="lg">
              <b-container>
                <b-row>
                  <b-col cols="6" class="">
                    <label class="d-block">Nomor SN</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newHardwareQualityControl.noSN[ttl-1]"  />
                  </b-col>
                  <b-col cols="6" class="">
                    <label class="d-block">Perangkat</label>
                    <smart-search init url="/api/master/seeker/hardware" key-tag="hardware_name" v-on:update="(data)=>newHardwareQualityControl.hardwareId[ttl-1]=data.id"></smart-search>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="">
                    <label class="d-block">Tanggal</label>
                    <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-newQc" v-model="newHardwareQualityControl.date[ttl-1]" class="mb-2">{{newHardwareQualityControl.date}}</b-form-datepicker>
                  </b-col>
                  <b-col cols="6" class="">
                    <label class="d-block">Komentar</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="newHardwareQualityControl.comment[ttl-1]"  />
                  </b-col>
                </b-row>
              </b-container>
            </b-modal>
          </template> -->
          <!-- Table JB -->
          <!-- <div class="w-100" v-if="selectedTab==1">
            <div class="col-12  my-2 py-0">
                <datatable :datas="hardwarequalitycontrols" :structure="hardwarequalitycontrolTableStructure" :init="loadData">
                    <template #head>
                        <th>Tindakan</th>
                    </template>
                    <template #addon="{item}">
                        <td>
                            <b-button v-b-modal.modal-edit-user class="btn btn-info mr-2"><b-icon icon="pencil-square"></b-icon></b-button>
                            <button v-on:click="deleteItem(item)" class="btn btn-danger"><b-icon icon="trash-fill"></b-icon></button>
                        </td>
                    </template>
                </datatable>
              </div>
          </div> -->

      </div>
    </div>
    <modal-delete url="/api/inventaris/hardware-qc/" @read="()=>{console.log('modal ready')}" @result="deleteResult" :targetid="deleteId">
      {{dicts.label_desc_delete[dicts.lang]}}:<br>
      <ul>
        <li>{{dicts.label_no_po[dicts.lang]}}: {{ itemToDelete.purchase_order!=null?itemToDelete.purchase_order.no_po:'-' }}</li>
        <!-- <li>Nomor SN: {{ itemToDelete.metadata!=null?itemToDelete.metadata[0].purchase_order_metadata.order.no_po:'-' }}</li> -->
      </ul>
    </modal-delete>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import {EventBus} from '../../eventbus';
    import * as axios from 'axios';
    import moment from 'moment';
    import Datatable from '../../components/Datatable.vue';
    import ChartCard from '../../components/Cards/ChartCard.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import SmartSearch from '../../components/SmartSearch.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    export default {
        components: {
        //   LTable,
          ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'smart-search':SmartSearch,
            'modal-delete':ModalDelete,
        },
        data () {
            return {
                stock:{
                  qc:[]
                },
                rowLimit:10,
                newhardwareqclabel:'',
                isMobile:false,
                nextUrl:null,
                prevUrl:null,
                newHardwares:0,
                newMetaCounter:0,
                itemToDelete:{},
                hardwarequalitycontrols:[],
                searchValue:'',
                deleteId:0,
                loadDataStock:true,
                loadData:true,
                deleteState:false,
                formAddHardwareQualityControlActive:false,
                savingNewHardwareQualityControl:false,
                savingBulk:false,
                errorNewHardwareQualityControl:false,
                errorBulk:false,
                errorHardwareQualityControlList:[],
                errorListBulk:[],
                existingClientResult:[],
                newHardwareQualityControlSaved:false,
                savedBulk:false,
                selectedTab:0,
                totalNewAntena:0,
                totalNewJB:0,
                selectedIdforEdit:0,
                selectedDetail:0,
                selectedToDelete:0,
                totalNewDetail:0,
                newMeta:{},
                ttl:0,
                deleteTargetId:0,
                updateSaved:false,
                errorUpdate:false,
                updating:false,
                deleteFail:false,
                deleted:false,
                metaEditIndex:0,
                used_qc:'no',
                addOnSmartSearch:{
                  hardware:{
                    no_po:'',
                    totalItem:0,
                    // item:'',
                  }
                },
                HardwareQcCart: {
                  month:'',
                  year:'',
                  data: {
                    labels: [],
                    series: [[]]
                  },
                  options: {
                    seriesBarDistance: 10,
                    axisX: {
                      showGrid: false
                    },
                    height: '245px',
                  },
                  responsiveOptions: [
                    // ['screen and (max-width: 640px)', {
                    //   seriesBarDistance: 5,
                    //   axisX: {
                    //     labelInterpolationFnc (value) {
                    //       return value[0]
                    //     }
                    //   }
                    // }]
                  ]
                },
                newHardwareQualityControl:{
                  sn:'',
                  // item:'antena',
                  noSN:[],
                  hardwareId:[],
                  date:[],
                  comment:[]
                },
                totalHardware:{
                  antena : 0,
                  cctv : 0,
                  jb : 0
                },
                findHardwareQc: true,
                listHardwareQcTotal: [
                  {
                    po_item:'JB',
                    total:0
                  },
                  {
                    po_item:'Antena',
                    total:0
                  },
                  {
                    po_item:'Telphon Thuraya',
                    total:0
                  },
                  {
                    po_item:'SENSOR RPM',
                    total:0
                  }
                ],
                formHardwareQualityControlActive:false,
                stockActive:false,
                hardwarequalitycontrolTableStructure:[
                    {label:'NO',key:null},
                    {
                      label:{
                        id:'PO NUMBER',
                        en:'PO NUMBER'
                      },
                      key:null
                    },
                    
                    {
                      label:{
                        id:'SERIAL NUMBER',
                        en:'SERIAL NUMBER'
                      },
                      key:null
                    },
                    {
                      label:{
                        id:'CATEGORY',
                        en:'CATEGORY'
                      },
                      key:null
                    },
                    {
                      label:{
                        id:'TYPES OF GOODS',
                        en:'TYPES OF GOODS'
                      },
                      key:null
                    },
                    {
                      label:{
                        id:'ACTION',
                        en:'ACTION'
                      },
                      key:null
                    }
                ],
                dicts:{
                  lang:'id',
                  label_tambah_hardware_qc:{
                      id:'Tambah Hardware QC baru',
                      en:'Add Hardware QC'
                  },
                  label_no_po:{
                      id:'Nomor PO',
                      en:'PO Number'
                  },
                  label_form_hardware_qc_baru:{
                      id:'Form Hardware QC',
                      en:'New Hardware QC form'
                  },
                  label_nomor_sn:{
                      id:'Nomor SN',
                      en:'SN number'
                  },
                  label_perangkat:{
                      id:'Nama perangkat',
                      en:'Hardware name'
                  },
                  label_tanggal:{
                      id:'Tanggal',
                      en:'Date'
                  },
                  label_keterangan:{
                      id:'Keterangan',
                      en:'Notes'
                  },
                  label_warehouse:{
                      id:'Gudang',
                      en:'Warehouse'
                  },
                  label_status:{
                      id:'status',
                      en:'status'
                  },
                  label_simpan:{
                      id:'Simpan',
                      en:'Submit'
                  },
                  label_tipe:{
                      id:'Tipe',
                      en:'Type'
                  },
                  label_tutup:{
                      id:'Tutup',
                      en:'Close'
                  },
                  label_desc_delete:{
                      id:'Yakin mau menghapus data dengan detail berikut',
                      en:'You are sure you want to delete data with the following details'
                  },
                  label_kode_barang:{
                      id:'Kode barang',
                      en:'Part number'
                  }
                },
                // statusTypeOptions:[
                //     {label:'Antena',value:'antena'},
                //     {label:'JB',value:'jb'},
                // ]
            }
        },
        
        created(){
          this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
          this.getHardwareQualityControls();
          this.getHardwareQCTotal();
          this.isMobile = this.$isMobile
          window.addEventListener('resize', ()=>{
            console.log('screen update')
            this.isMobile = screen.width < 768
          });
          this.dicts.lang = localStorage.getItem('lang');
          EventBus.$on('lang',()=>{
            console.log('changing Hardware QC lang')
            this.dicts.lang = localStorage.getItem('lang');
          });
          this.getStock();
          // var newData = [];
          // for(var x=0;x<100;x++){
          //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
          // }
          // console.log(newData);
          // this.users = newData;
        },
        methods:{
          getStock(url=(this.$baseUrl+'/api/stock/qc')){//stok keseluruhan
            this.loadDataStock=true
            axios.post(url,{},{
                'headers':{
                  'Authorization':'Bearer '+localStorage.getItem('accessToken')
                }
              }
            ).then((result)=>{
              console.log(result)
              this.stock.qc = result.data;
              var data = []
              var label = []
              if(typeof result.data == typeof []){
                result.data.forEach(val=>{
                  data.push(val.total)
                  label.push(val.po_item)
                })
              }
              this.HardwareQcCart.data = {
                labels : label,
                series : [data]
              }
              this.loadDataStock=false
            }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
              console.log(err)
              this.loadDataStock=false
            })
          },
            changePage(isNext){
                this.getHardwareQualityControls(isNext?this.nextUrl:this.prevUrl)
            },
            calculateTotalNew(meta){
              this.newHardwares = []
              for(var a=0;a<meta.length;a++){
                console.log('meta qty: '+meta[a].qty)
                console.log('meta hardware: '+meta[a].hardware.hardware_name)
                for(var b=0;b<meta[a].qty;b++){
                  console.log('meta id: '+meta[a].id)
                  this.newHardwares.push({id:meta[a].id,name:meta[a].hardware.hardware_name})
                }
              }
            },
            newMetaCounterGenerator(){
              this.newMetaCounter = this.newMetaCounter + 1;
              return this.newMetaCounter
            },
            deleteResult(deleted){
              console.log(deleted)
              if(deleted){
                this.getHardwareQualityControls();
              }
            },
            clearPOData(){
              this.newHardwareQualityControl.sn='';
              this.addOnSmartSearch.hardware.no_po=''
              this.totalNewDetail=0
              this.newHardwares=[]
              this.newHardwareQualityControl.noSN=[]
              this.newHardwareQualityControl.date=[]
              this.newHardwareQualityControl.comment=[]
            },
            smartSearchUpdatedNoPo(){
              this.hardwarequalitycontrols[this.selectedIdforEdit].no_po_id=data.id
              
            },
            updateMetaHardwareQc(data,idx){
              console.log(data.po_metadata.id)
              this.newHardwareQualityControl.hardwareId[idx]=data.po_metadata.id;
            },
            editMetaHardwareQc(data){
              this.hardwarequalitycontrols[this.selectedIdforEdit].metadata[0].hardware_id=data.id
              console.log(hardwarequalitycontrols[this.selectedIdforEdit])
            },
            getDeleteUrl(){
              return '/api/inventaris/hardware-qc/'+this.deleteTargetId;
            },
            addNewHardware(){
                this.newHardwareQualityControl.noSN;
                this.newHardwareQualityControl.hardwareId;
                this.newHardwareQualityControl.date;
                this.newHardwareQualityControl.comment;
                this.totalNewDetail++;
                console.log(this.newHardwareQualityControl)
            },
            deleteNewHardware(index){
                this.newHardwareQualityControl.noSN.splice(index,1);
                this.newHardwareQualityControl.hardwareId.splice(index,1);
                this.newHardwareQualityControl.date.splice(index,1);
                this.newHardwareQualityControl.comment.splice(index,1);
                this.totalNewDetail--;
            },
            getHardwareQualityControls(url=(this.$baseUrl+'/api/inventaris/hardware-qc?limit='+this.rowLimit)){
                this.loadData=true
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result.data.data)
                    this.prevUrl = result.data.prev_page_url
                    this.nextUrl = result.data.next_page_url
                    this.hardwarequalitycontrols = result.data.data;
                    // console.log(this.hardwarequalitycontrols)
                    this.loadData=false
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                      localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err)
                    this.loadData=false
                })
            },
            getHardwareQCTotal(){
              this.findHardwareQc = true;
                axios.post(this.$baseUrl+'/api/report/json/quality-control',{'type':this.used_qc},{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                  this.findHardwareQc = false;
                  this.listHardwareQcTotal = result.data;
                }).catch((err)=>{
                  this.findHardwareQc = false;
                  this.listHardwareQcTotal = [];
                })
            },
            fillHardware(index,value,hardwareId){
              console.log('hardware id: '+hardwareId)
              if(this.newHardwareQualityControl.noSN[index]!=""){
                console.log("contain id")
                this.newHardwareQualityControl.hardwareId[index]=hardwareId
                //this.newHardwareQualityControl.hardwareId[index]=value
              }else{
                this.newHardwareQualityControl.hardwareId[index]=null
              }
            },
            saveNewHardwareQc(){
                //if(this.newPurchaseOrder.no_po!=''){}
                // console.log(this.newPurchaseOrderSaved)
                // return;
                  
                  this.savingNewHardwareQualityControl=true
                  this.errorNewHardwareQualityControl=false
                  console.clear()
                  console.log(this.newHardwareQualityControl)
                if(
                  this.newHardwareQualityControl.sn != '' && 
                  // this.newHardwareQualityControl.item != '' && 
                  this.newHardwareQualityControl.noSN != '' &&
                  this.newHardwareQualityControl.hardwareId != '' && 
                  this.newHardwareQualityControl.date != '' 
                  // this.newHardwareQualityControl.comment != ''
                  ){
                    axios.post(this.$baseUrl+'/api/inventaris/hardware-qc',{
                        'no_po_id':this.newHardwareQualityControl.sn,
                        // 'item':this.newHardwareQualityControl.item,
                        'serial_number':this.newHardwareQualityControl.noSN,
                        'purchase_order_metadata_id':this.newHardwareQualityControl.hardwareId,
                        'date':this.newHardwareQualityControl.date,
                        'comment':this.newHardwareQualityControl.comment,
                    },
                    {
                        'headers':
                            {'Authorization':'Bearer '+localStorage.getItem('accessToken')}
                    }).then((result)=>{
                        console.log(result)
                        this.savingNewHardwareQualityControl=false
                        this.newHardwareQualityControlSaved=true
                        this.getHardwareQualityControls()
                        this.resetFormHardwareQC()

                        setTimeout(() => {
                            this.formHardwareQualityControlActive=false
                            this.newHardwareQualityControlSaved=false
                            this.newHardwares=[]
                        }, 1000);
                    }).catch((err)=>{
                        //check if token fail
                        if(err.response && err.response.status==401){
                          localStorage.removeItem('accessToken')
                        this.$router.push('/login')
                        }
                        console.log(err)
                        this.errorHardwareQualityControlList=[]
                        this.errorHardwareQualityControlList=Object.values(err.response.data.errors)
                        console.log(this.errorHardwareQualityControlList)
                        this.savingNewHardwareQualityControl=false
                        this.errorNewHardwareQualityControl=true
                    })
                }else{
                  console.log('data invalid')
                  this.errorNewHardwareQualityControl=true
                  this.savingNewHardwareQualityControl=false
                  this.errorHardwareQualityControlList=[]
                  if(this.newHardwareQualityControl.sn=''){
                    this.errorHardwareQualityControlList.push(["- Mohon isi nomor PO"])
                  }
                  if(this.newHardwareQualityControl.noSN=''){
                    this.errorHardwareQualityControlList.push(["- Mohon isi nomor SN/JB"])
                  }
                  if(this.newHardwareQualityControl.hardwareId=''){
                    this.errorHardwareQualityControlList.push(["- Mohon isi hardware"])
                  }
                  if(this.newHardwareQualityControl.date=''){
                    this.errorHardwareQualityControlList.push(["- Mohon isi tanggal"])
                  }
                }
            },
            saveNewHardwareQcBulk(){
                  this.updating=true
                  this.errorUpdate=false
                  console.clear()
                  console.log(this.newHardwareQualityControl)
                
                    axios.post(this.$baseUrl+'/api/inventaris/hardware-qc-metadata-bulk',{
                        'metadatas':this.hardwarequalitycontrols[this.selectedIdforEdit].metadata,
                    },
                    {
                        'headers':
                            {'Authorization':'Bearer '+localStorage.getItem('accessToken')}
                    }).then((result)=>{
                        console.log(result)
                        this.updating=false
                        this.updateSaved=true
                        this.getHardwareQualityControls()

                        setTimeout(() => {
                            this.updateSaved=false
                        }, 1000);
                    }).catch((err)=>{
                        //check if token fail
                        if(err.response && err.response.status==401){
                          localStorage.removeItem('accessToken')
                        this.$router.push('/login')
                        }
                        console.log(err)
                        this.updating=false
                        this.errorUpdate=true
                    })
                // }else{
                //   console.log('data invalid')
                //   this.errorNewHardwareQualityControl=true
                //   this.savingNewHardwareQualityControl=false
                //   this.errorHardwareQualityControlList=[]
                //   if(this.newHardwareQualityControl.sn=''){
                //     this.errorHardwareQualityControlList.push(["- Mohon isi nomor PO"])
                //   }
                //   if(this.newHardwareQualityControl.noSN=''){
                //     this.errorHardwareQualityControlList.push(["- Mohon isi nomor SN/JB"])
                //   }
                //   if(this.newHardwareQualityControl.hardwareId=''){
                //     this.errorHardwareQualityControlList.push(["- Mohon isi hardware"])
                //   }
                //   if(this.newHardwareQualityControl.date=''){
                //     this.errorHardwareQualityControlList.push(["- Mohon isi tanggal"])
                //   }
                // }
            },
            resetFormHardwareQC(){
              this.newHardwareQualityControl.sn=""
                          // 'item':this.newHardwareQualityControl.item,
              this.newHardwareQualityControl.noSN=[]
              this.newHardwareQualityControl.hardwareId=[]
              this.newHardwareQualityControl.date=[]
              this.newHardwareQualityControl.comment=[]
            },
            setNewPO(metadata=null){
                if(metadata!=null){
                    this.newHardwareQualityControl.hardwareId = metadata.hardware_id
                }
            },
            updateNewHardwareQcStatus(data){
                // this.newHardwareQualityControl.item_po=data
                this.addOnSmartSearch.hardware.no_po=data
            },
            newUsernameChange(){
                this.newHardwareQualityControl.password = this.newHardwareQualityControl.username.toUpperCase();
            },
            deleteItem(item){
                this.deleteTargetId = item.id
            },
            setNewClientId(newId){
                this.newHardwareQualityControl.clientId = newId;
                console.log(this.newHardwareQualityControl.clientId)
            },
            deleteData(){
              this.deleteState=true
              axios.delete(this.$baseUrl+'/api/inventaris/hardware-qc/'+this.hardwarequalitycontrols[this.selectedToDelete].id,{
                  headers:{'Authorization':'Bearer '+ localStorage.getItem('accessToken')}
              })
              .then((result)=>{
                  if(result.status==200){
                      this.hardwarequalitycontrols.splice(this.selectedToDelete,1);
                      this.deleted=true;
                      setTimeout(() => {
                          this.deleted=false;
                      }, 1000);
                      
                  }else{
                      this.deleteFail=true
                  }
                  this.deleteState=false
              }).catch((err)=>{
                  //check if token fail
                  if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                  this.$router.push('/login')
                  }
                  console.log(err.response)
                  this.deleteState=false
                  this.deleteFail=true
              })
            },
            smartSearchPO(data){
                this.newPurchaseOrder.vendor_id=data.id
            },
            updateHardwareQualityControl(index){
              console.clear()
              console.log(this.hardwarequalitycontrols[this.selectedIdforEdit].metadata[index])
              this.updating=true
              this.errorUpdate=false
              this.metaEditIndex = index
              axios.put(this.$baseUrl+'/api/inventaris/hardware-qc-metadata/'+this.hardwarequalitycontrols[this.selectedIdforEdit].metadata[index].id,this.hardwarequalitycontrols[this.selectedIdforEdit].metadata[index],{
                  headers:{'Authorization':'Bearer '+ localStorage.getItem('accessToken')}
              }).then((result)=>{
                  if(result.status=200){
                      this.updating=false
                      this.updateSaved=true
                      this.getHardwareQualityControls()
                      setTimeout(() => {
                          this.updateSaved=false
                      }, 1000);
                  }
                  console.log(result)
              }).catch((err)=>{
                  //check if token fail
                  if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                  this.$router.push('/login')
                  }
                  this.updating=false
                  this.errorUpdate=true
                  console.log(err.response)
              })
            },
            deleteModalClose(mdl){
              if(this.deleteState){
                console.log('deleting')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-delete-po');
              }
            },
            detailModalClose(mdl){
              if(this.deleteState){
                console.log('detail')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-detail-hardwareqc');
              }
            },
            editModalClose(mdl){
              this.getHardwareQualityControls()
              if(this.deleteState){
                console.log('edit')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-edit-hardwareqc');
              }
            },
            moment: function (date) {
              return moment(date);
            }
        },
    }
</script>
<style scoped>
.table th, .table td {
    border-top: 0;
}

.btn {
    padding:2px 6px;
}
/* ::v-deep .modal-content {
    margin: -4.50rem auto;
} */
.table-detail {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
}
.table-detail, th, td {
  text-align: center;
  padding: 8px;
  border: 1px solid #ddd;
}
::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3rem);
}
::v-deep .modal.show .modal-dialog{
    transform:none;
    -webkit-transform: none;
}
</style>